import React from 'react';
import SvgArrowReturn from '../../components/svg/commons/arrow_return';

export const SliderSlickButton = ({ _className, onClick }) =>{
    return (
        <div className={_className} onClick={onClick}>
            <SvgArrowReturn/>
        </div>
    )
}